(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["av-panel-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('av-panel-menu'))customElements.define('av-panel-menu',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('.av-panel-trigger');this.trigger.addEventListener('click',()=>{this.dialog.showModal();this.trigger.setAttribute('aria-expanded','true')});this.querySelector('.av-panel-close').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('close',()=>{this.trigger.setAttribute('aria-expanded','false');this.trigger.focus()});this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX>r.right||e.clientX<r.left)this.dialog.close()}const b=e.target.closest('[data-panel]');if(b){this.showPanel(b.dataset.panel);return}if(e.target.closest('[data-back]')){this.dialog.removeAttribute('data-expanded');this.querySelector('.av-panel-secondary').hidden=true;this.querySelectorAll('[aria-controls]').forEach(x=>x.setAttribute('aria-expanded','false'))}})}
showPanel(id){const target=this.querySelector('#'+id);if(!target)return;this.querySelectorAll('.av-panel-content').forEach(x=>x.hidden=x!==target);this.querySelector('.av-panel-secondary').hidden=false;this.dialog.setAttribute('data-expanded','');this.querySelectorAll('[aria-controls]').forEach(x=>x.setAttribute('aria-expanded',String(x.dataset.panel===id||id.startsWith('av-child-'+x.dataset.panel.replace('av-panel-','')+'-'))));this.querySelector('.av-panel-secondary').scrollTop=0;target.querySelector('button')?.focus()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["av-pilot-sill-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-pilot-sill-information')) {
    customElements.define('av-pilot-sill-information', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const tabs = [...this.querySelectorAll('[data-av-tab]')];
        const panels = [...this.querySelectorAll('[data-av-content]')];
        if (tabs.length !== panels.length || !tabs.length) return;
        const prefix = `av-info-${crypto.randomUUID()}`;
        this.querySelector('.av-information__nav').setAttribute('role', 'tablist');
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, i) => {
          tab.id = `${prefix}-tab-${i}`;
          panels[i].id = `${prefix}-panel-${i}`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[i].id);
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
          panels[i].tabIndex = 0;
          tab.addEventListener('click', () => select(i));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          });
        });
        select(0);
        this.setAttribute('data-ready', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["av-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-product-information')) {
    customElements.define('av-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const tabs = [...this.querySelectorAll('[data-av-tab]')];
        const panels = [...this.querySelectorAll('[data-av-content]')];
        if (tabs.length !== panels.length || !tabs.length) return;
        const prefix = `av-info-${crypto.randomUUID()}`;
        this.querySelector('.av-information__nav').setAttribute('role', 'tablist');
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, i) => {
          tab.id = `${prefix}-tab-${i}`;
          panels[i].id = `${prefix}-panel-${i}`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[i].id);
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
          panels[i].tabIndex = 0;
          tab.addEventListener('click', () => select(i));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          });
        });
        select(0);
        this.setAttribute('data-ready', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
